import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";

const GetAgentRoles = async () => {
  /**
   * input: null
   * output: agent roles object
   * description: fetches agent roles
   */
  try {
    const agentCollection = await doc(db, "roles", "agent");
    const agentsSnapshot = await getDoc(agentCollection);
    const agentRoles = agentsSnapshot.data();

    return agentRoles;
  } catch (error) {
    console.log(error);
  }
};

export default GetAgentRoles;
